exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: -ms-grid;\n  display: grid;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: var(--padding);\n  gap: var(--padding); }\n  :host img {\n    width: 15rem;\n    margin: auto;\n    opacity: 0.15; }\n  :host #overlay {\n    display: -ms-flexbox;\n    display: flex; }\n    :host #overlay > div {\n      -ms-flex: 1;\n          flex: 1;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n          flex-direction: column;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n      padding: var(--padding);\n      gap: var(--padding); }\n    :host #overlay i {\n      opacity: 0.2;\n      font-size: 10vw;\n      margin: 0 auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/project/project-upload/project-upload.component.scss
// module id = ../../../../../src/app/project/project-upload/project-upload.component.scss
// module chunks = main